//import jwt from 'jsonwebtoken';
//import { secretKey } from '../backend/config.js';
import { apiBaseUrl } from '../../backend/config.js'; 

function getAuthToken() {
  return localStorage.getItem('token');  // Retrieves the token from localStorage
}

export { getAuthToken };